import i18n from '../i18n.js';

const API_BASE = import.meta.env['VITE_API_URL'] ?? '';

function getDemoHeaders(): Record<string, string> {
  try {
    const raw = localStorage.getItem('demoPersona');
    if (raw) {
      const p = JSON.parse(raw) as { role?: string; userId?: string };
      if (p.role && p.userId) {
        return { 'x-demo-role': p.role, 'x-demo-user-id': p.userId };
      }
    }
  } catch {
    // ignore
  }
  return { 'x-demo-role': 'brand_approver' };
}

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'Accept-Language': i18n.language ?? 'id',
    ...getDemoHeaders(),
    ...(options.headers as Record<string, string> | undefined ?? {}),
  };

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (!res.ok) {
    const body = await res.json().catch(() => ({ messageKey: 'errors.internalServerError' })) as Record<string, unknown>;
    const key = (body['messageKey'] as string | undefined) ?? 'errors.internalServerError';
    const err = Object.assign(new Error(i18n.t(key)), { body });
    throw err;
  }

  return res.json() as Promise<T>;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body: unknown) =>
    request<T>(path, { method: 'POST', body: JSON.stringify(body) }),
  put: <T>(path: string, body: unknown) =>
    request<T>(path, { method: 'PUT', body: JSON.stringify(body) }),
  patch: <T>(path: string, body: unknown) =>
    request<T>(path, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
};
